import {
  useWSModal,
  WSActions,
  WSAlert,
  WSElement,
  WSFlexBox,
  WSPanel
} from "@wingspanhq/fe-component-library";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces";
import { FieldView } from "../../../shared/components/FieldView/FieldView";
import React from "react";

export interface DeletionNotAllowedModalProps {
  payeeId: string;
  payeeName: string;
  engagement: IPayeeEngagementResponse;
  onClose: () => void;
}

export const DeletionNotAllowedModal: React.FC<
  DeletionNotAllowedModalProps
> = ({ payeeName, engagement, onClose }) => {
  return (
    <>
      <WSPanel>
        <WSFlexBox gap="XL">
          <FieldView
            label="Assignment name"
            value={engagement.engagementName}
          />
          <FieldView label="Contractor name" value={payeeName} />
        </WSFlexBox>
      </WSPanel>

      <WSAlert
        my="2XL"
        theme="warning"
        icon="alert"
        size="M"
        title="Assignment cannot be deleted when:"
      >
        <WSElement as="ul" ml="L">
          <li>Active invoices exist.</li>
          <li>Historical payment data (e.g. invoices) exists</li>
        </WSElement>
        If this assignment is no longer used, it can be archived instead.
      </WSAlert>

      <WSActions
        alignment="fill"
        buttons={[
          {
            label: "Done",
            onClick: onClose,
            kind: "Secondary"
          }
        ]}
      />
    </>
  );
};

export const useDeletionNotAllowedModal = () => {
  return useWSModal(DeletionNotAllowedModal, {
    title: "Delete assignment",
    size: "M"
  });
};
